export default "__VITE_ASSET__jRBYe96K__"